import { render, staticRenderFns } from "./ActivixSelect.vue?vue&type=template&id=75da37d0&"
import script from "./ActivixSelect.vue?vue&type=script&lang=js&"
export * from "./ActivixSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports